// US common holidays with correct per-year dates (fixed + floating + Easter/Computus).
// Leap years handled natively by JS Date.

const pad = (n) => String(n).padStart(2, "0");
const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// nth weekday of a month. month 0-indexed, weekday 0=Sun..6=Sat, n=1..5
function nthWeekday(year, month, weekday, n) {
  const first = new Date(year, month, 1);
  const offset = (weekday - first.getDay() + 7) % 7;
  return new Date(year, month, 1 + offset + (n - 1) * 7);
}
// last given weekday of a month
function lastWeekday(year, month, weekday) {
  const last = new Date(year, month + 1, 0);
  const offset = (last.getDay() - weekday + 7) % 7;
  return new Date(year, month, last.getDate() - offset);
}
// Easter Sunday (Anonymous Gregorian algorithm). Returns Date.
function easter(year) {
  const a = year % 19, b = Math.floor(year / 100), c = year % 100;
  const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31); // 3=March, 4=April
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

// rule: how the date is determined (shown as a hint in the UI)
function holidaysForYear(y) {
  const out = [];
  const add = (name, date, rule) => out.push({ name, date: iso(date), rule });
  add("New Year's Day", new Date(y, 0, 1), "January 1");
  add("Martin Luther King Jr. Day", nthWeekday(y, 0, 1, 3), "3rd Monday of January");
  add("Valentine's Day", new Date(y, 1, 14), "February 14");
  add("Presidents' Day", nthWeekday(y, 1, 1, 3), "3rd Monday of February");
  add("St. Patrick's Day", new Date(y, 2, 17), "March 17");
  add("Easter Sunday", easter(y), "Sunday after the first spring full moon");
  add("Mother's Day", nthWeekday(y, 4, 0, 2), "2nd Sunday of May");
  add("Memorial Day", lastWeekday(y, 4, 1), "Last Monday of May");
  add("Juneteenth", new Date(y, 5, 19), "June 19");
  add("Father's Day", nthWeekday(y, 5, 0, 3), "3rd Sunday of June");
  add("Independence Day", new Date(y, 6, 4), "July 4");
  add("Labor Day", nthWeekday(y, 8, 1, 1), "1st Monday of September");
  add("Columbus Day / Indigenous Peoples' Day", nthWeekday(y, 9, 1, 2), "2nd Monday of October");
  add("Halloween", new Date(y, 9, 31), "October 31");
  add("Veterans Day", new Date(y, 10, 11), "November 11");
  const thanksgiving = nthWeekday(y, 10, 4, 4);
  add("Thanksgiving", thanksgiving, "4th Thursday of November");
  const blackFriday = new Date(thanksgiving); blackFriday.setDate(thanksgiving.getDate() + 1);
  add("Day after Thanksgiving", blackFriday, "Friday after Thanksgiving");
  add("Christmas Eve", new Date(y, 11, 24), "December 24");
  add("Christmas Day", new Date(y, 11, 25), "December 25");
  add("New Year's Eve", new Date(y, 11, 31), "December 31");
  return out;
}

// Upcoming holidays from today across the next ~2 years, sorted ascending.
export function upcomingHolidays() {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const y = now.getFullYear();
  const all = [...holidaysForYear(y), ...holidaysForYear(y + 1), ...holidaysForYear(y + 2)];
  return all
    .filter((h) => new Date(h.date + "T00:00:00") >= today)
    .sort((a, b) => a.date.localeCompare(b.date));
}

export function formatHolidayDate(dateStr) {
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric", year: "numeric" });
}
